import React from 'react';

const ProductCard = ({ product, onPreview, onEdit, onDelete }) => {
  const displayPrice = String(product.price ?? '').replace(/\$/g, '₹');

  return (
    <div className="group relative bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden cursor-pointer">
      {/* Image */}
      <div className="aspect-square overflow-hidden" onClick={() => onPreview(product)}>
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
      </div>

      {/* Action Buttons */}
      <div className="absolute top-4 right-4 flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onEdit(product);
          }}
          className="p-2 rounded-full bg-white/90 hover:bg-white text-stone-600 hover:text-stone-900 transition-colors shadow-lg"
          title="Edit Product"
        >
          <span className="material-symbols-outlined text-sm">edit</span>
        </button>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDelete(product);
          }}
          className="p-2 rounded-full bg-red-500/90 hover:bg-red-500 text-white transition-colors shadow-lg"
          title="Delete Product"
        >
          <span className="material-symbols-outlined text-sm">delete</span>
        </button>
      </div>

      {/* Content */}
      <div className="p-6">
        <h3 className="text-xl font-bold mb-2" style={{color: '#3E3E3E'}}>
          {product.name}
        </h3>
        
        <p className="text-2xl font-bold mb-3" style={{color: '#C8A96A'}}>
          {displayPrice}
        </p>

        <p className="text-sm text-stone-600 line-clamp-2">
          {product.description}
        </p>

        {/* CTA Button */}
        <button 
          onClick={() => onPreview(product)}
          className="mt-4 w-full px-4 py-2 rounded-full font-medium transition-all duration-300 text-sm hover:scale-105"
          style={{backgroundColor: '#C8A96A', color: '#FFFFFF'}}
        >
          View Details
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
